
        <img src="https://{{imgTitle_params.imgSrc}}" alt="foto nuestros valores" class="img-full-cover position-absolute top-0right-0" alt="{{imgTitle_params.imgAlt}}">
    <div class="tit-stroke" data-aos="zoom-in-down" data-aos-duration="1500">
        <h1 class="vlt-stroke-text light preline_title">{{imgTitle_params.title}}</h1>
        <div>
            <div class="vlt-stroke-num">{{imgTitle_params.num}}</div>
        </div>
   </div>
